module.exports = __webpack_public_path__ + "a597e0887c0044efd594b868cdb77dc8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/moderne_inactive.svg
// module id = 30
// module chunks = 0